import { Directive, EventEmitter, HostListener, Input, Output, TemplateRef } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { IOption } from '../../models/option.model';
import { ConfirmDialogComponent } from './confirm-dialog.component';

@Directive({
  selector: '[appConfirmDialog]',
  standalone: true,
  exportAs: 'appConfirmDialog',
})
export class ConfirmDialogDirective {
  @Input() confirmTitle: string;
  @Input() confirmEntityName: string;
  @Input() confirmMessage: string;
  @Input() confirmButtonText: string;
  @Input() confirmButtonIcon: string;
  @Input() cancelButtonText: string;
  @Input() warningMessage: string;
  @Input() confirmList: string[];
  @Input() confirmEntityType: 'serviceReport' | 'correctiveAction';
  @Input() confirmButton: 'primary' | 'warn-secondary';
  @Input() showAreYouSure = true;
  @Input() ownPunctuationMark = false;
  @Input() manualTrigger = false;
  @Input() content: TemplateRef<any>;
  @Input() confirmChoiceControl: FormControl<number | null> | null;
  @Input() confirmChoiceOptions: IOption[] | null;
  @Output() confirmed = new EventEmitter<void>();

  constructor(private dialog: MatDialog) {}

  @HostListener('click')
  handleClick(): void {
    if (this.manualTrigger) {
      return;
    }
    this.openDialog();
  }

  openDialog(): void {
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      data: {
        title: this.confirmTitle,
        entityName: this.confirmEntityName,
        message: this.confirmMessage,
        warningMessage: this.warningMessage,
        list: this.confirmList,
        entityType: this.confirmEntityType,
        confirmButtonText: this.confirmButtonText,
        confirmButtonIcon: this.confirmButtonIcon,
        cancelButtonText: this.cancelButtonText,
        confirmButton: this.confirmButton,
        showAreYouSure: this.showAreYouSure,
        ownPunctuationMark: this.ownPunctuationMark,
        content: this.content,
        choiceControl: this.confirmChoiceControl,
        choiceOptions: this.confirmChoiceOptions,
      },
      panelClass: 'mobile-sizing-for-mat-dialogs',
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.confirmed.emit();
      }
      this.confirmChoiceControl?.reset();
    });
  }
}
